module.exports = __webpack_public_path__ + "static/media/PPCC_V2.d8e8f60f.png";